<div class="field mb-4 flex flex-column relative">
  @if(isMapScriptLoaded()){
  <google-map
    height="400px"
    width="auto"
    [options]="options()"
    (mapInitialized)="onMapLoaded()"
  >
    @for (marker of markerPositions(); track $index) { @if(marker.position){
    <map-marker
      [position]="marker.position"
      [options]="markerOptions"
      (mapDragend)="mapDragend.emit($event)"
    />
    } }
  </google-map>
  }@else {
  <p-skeleton height="12rem" styleClass="absolute top-0 left-0" />
  }
</div>
